import React from 'react'
import PropTypes from 'prop-types'
import StickyHeader from 'components/StickyHeader'
import StickyHeaderWrapper from 'components/common/StickyHeaderWrapper'
import { MAIN_CONTENT, FOOTER } from 'constant'

const OneColumnTireLinePage = ({ placeholders: { footer = [], header = [], mainTireContent = []} = {}, ...props }) =>
  <React.Fragment>
    <StickyHeaderWrapper>
      { header }
      <StickyHeader />
    </StickyHeaderWrapper>
    <main id={ MAIN_CONTENT } tabIndex="-1" data-max-width data-max-width-padding>
      { mainTireContent }
    </main>
    <div id={ FOOTER }>
      { footer }
    </div>
  </React.Fragment>

OneColumnTireLinePage.propTypes = {
  metaKeywords: PropTypes.string,
  name: PropTypes.string,
  placeholders: PropTypes.shape({
    footer: PropTypes.array,
    header: PropTypes.array,
    mainTireContent: PropTypes.array
  })
}

OneColumnTireLinePage.type = 'OneColumnTireLinePage'
OneColumnTireLinePage.placeholders = ['footer', 'header', 'mainTireContent']

export default OneColumnTireLinePage
